module.exports = __webpack_public_path__ + "img/logo-gov-co.b690a769.png";